/**
 * User notification API – all endpoints used by notification pages and header.
 * Base path: /org/usernotification
 */
import { POST } from '../apiController';

const ORG_USER_NOTIFICATION = '/user/usernotification';

export const getNotifications = (data = {}) => {
  return POST(`${ORG_USER_NOTIFICATION}/get_notifications`, data).then((response) => {
    const payload = response?.data || {};
    const normalized = payload?.response || payload;

    return {
      ...response,
      ...normalized,
      notifications: normalized?.notifications || payload?.notifications || [],
      pagination: normalized?.pagination || payload?.pagination || null,
      raw: response,
    };
  });
};

export const markNotificationAsRead = (data) => {
  return POST(`${ORG_USER_NOTIFICATION}/mark_notification_as_read`, data);
};

export const markAllNotificationsAsRead = () => {
  return POST(`${ORG_USER_NOTIFICATION}/mark_all_notifications_as_read`);
};

export const getCourseDetailsByIdForNotification = (data) => {
  return POST(`${ORG_USER_NOTIFICATION}/get_course_details_for_notification`, data);
};
